import React from 'react'
import CardServicos from './cardServicos'
import Container from './container'

export default function LinksVertical({ areasData }) {
  if (!areasData || areasData.length === 0) {
    return null
  }

  return (
    <div className="w-full bg-[#040116] py-20 relative overflow-hidden">
      {/* Background com grafismos */}
      <div className="absolute inset-0 opacity-10">
        <img
          src="/assets/grafismos.svg"
          className="w-full h-full object-cover"
          alt=""
        />
        <img
          src="/assets/grafismos.svg"
          className="absolute inset-0 w-full h-full object-cover rotate-180"
          alt=""
        />
      </div>

      <Container className="relative z-10">
        <div className="flex flex-col lg:flex-row justify-center items-center gap-12">
          {areasData.map((area, index) => (
            <CardServicos
              key={index}
              icon={area.icon}
              iconHover={area.iconHover}
              title={area.title}
              text={area.text}
              glowColor={area.glowColor}
              url={area.url}
              className="md:w-full lg:w-[350px]"
            />
          ))}
        </div>
      </Container>
    </div>
  )
}
